import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2Component } from './conservazione-carica-documento-giornali-schede-magazzino-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-giornali-schede-magazzino-step2', {
            url: '/conservazione-carica-giornali-schede-magazzino',
            ncyBreadcrumb: {
                label: 'Carica Giornali e Schede di Magazzino',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-giornali-schede-magazzino-step2 flex="100"></conservazione-carica-documento-giornali-schede-magazzino-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2Module: string = ng
    .module('conservazione-carica-documento-giornali-schede-magazzino-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2', ConservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-giornali-schede-magazzino-step2/conservazione-carica-documento-giornali-schede-magazzino-step2.module.ts